import esLocales from './lan/es';

const locales = {
    es: esLocales,
    en: {}
}

export default locales;